import { useEffect, useRef, useState } from "react";
import { createChart } from "lightweight-charts";
import { useTerminal } from "@/lib/terminal";

const RES = ["1", "5", "15", "60"];

export const PriceChart = ({ address }) => {
  const { api } = useTerminal();
  const el = useRef(null);
  const series = useRef(null);
  const chartRef = useRef(null);
  const fitted = useRef(false);
  const [res, setRes] = useState("1");

  useEffect(() => {
    const chart = createChart(el.current, {
      autoSize: true,
      localization: { locale: "tr-TR" },
      layout: { background: { color: "#101216" }, textColor: "#94A3B8", fontFamily: "JetBrains Mono" },
      grid: { vertLines: { color: "#161920" }, horzLines: { color: "#161920" } },
      timeScale: { timeVisible: true, borderColor: "#222634" },
      rightPriceScale: { borderColor: "#222634" },
    });
    chartRef.current = chart;
    series.current = chart.addCandlestickSeries({
      upColor: "#00E676", downColor: "#FF5252", borderVisible: false, wickUpColor: "#00E676", wickDownColor: "#FF5252",
      priceFormat: { type: "price", precision: 10, minMove: 1e-10 },
    });
    return () => chart.remove();
  }, []);

  useEffect(() => {
    fitted.current = false;
    let alive = true;
    const load = async () => {
      try {
        const d = await api("get", `/chart/${address}?resolution=${res}`);
        if (!alive || d.s !== "ok") return;
        series.current.setData(d.t.map((t, i) => ({ time: t, open: d.o[i], high: d.h[i], low: d.l[i], close: d.c[i] })));
        if (!fitted.current) { chartRef.current.timeScale().fitContent(); fitted.current = true; }
      } catch {}
    };
    load();
    const t = setInterval(load, 8000);
    return () => { alive = false; clearInterval(t); };
  }, [api, address, res]);

  return (
    <div className="border border-[#222634] rounded-md bg-[#101216] overflow-hidden" data-testid="price-chart">
      <div className="flex items-center gap-1 px-2 h-9 border-b border-[#222634]">
        {RES.map((r) => (
          <button key={r} data-testid={`chart-res-${r}`} onClick={() => setRes(r)}
            className={`px-2 py-0.5 rounded text-xs font-mono transition-colors ${res === r ? "bg-[#161920] text-slate-100" : "text-slate-500 hover:text-slate-300"}`}>
            {r === "60" ? "1sa" : `${r}dk`}
          </button>
        ))}
        <span className="ml-auto text-[10px] font-mono text-slate-600">USD · full.fun</span>
      </div>
      <div ref={el} className="h-[380px]" />
    </div>
  );
};
